import * as types from '../constants/idpAdminActions';
import * as messageConstants from "../shared/messages";

const initialState = {
  errorMsg: null,
  successMsg: null,
  fetchingAzureAdList: true,
  azureAdList: [],
};

export default function orgs(state = initialState, action = {}) {
  switch (action.type) {
    case types.ADD_AZURE_AD_START:
      return {
        ...state,
        errorMsg: null,
        successMsg: null
      };
    case types.ADD_AZURE_AD_SUCCESS:
      return {
        ...state,
        errorMsg: null,
        successMsg: messageConstants.ADD_AZURE_SUCCESS
      };
    case types.ADD_AZURE_AD_FAIL:
      return {
        ...state,
        errorMsg: action.errorMsg,
        successMsg: null
      };

    case types.DELETE_AZURE_AD_START:
      return {
        ...state,
        deleteAzureAdInProgress: true
      };
    case types.DELETE_AZURE_AD_SUCCESS:
      return {
        ...state,
        deleteAzureAdInProgress: false,
      };
    case types.DELETE_AZURE_AD_FAIL:
      return {
        ...state,
        deleteAzureAdInProgress: false,
      };

    case types.GET_AZURE_AD_LIST_START:
      return {
        ...state,
        fetchingAzureAdList: true,
      };
    case types.GET_AZURE_AD_LIST_SUCCESS:
      return {
        ...state,
        fetchingAzureAdList: false,
        azureAdList: action.response,
      };
    case types.GET_AZURE_AD_LIST_FAIL:
      return {
        ...state,
        fetchingAzureAdList: false,
        //TODO: keep existing list on failure or clear it out?
        // azureAdList: [],
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/azure.js